<template>
  <md-card class="md-card-stats" style="min-width: 250px">
    <div
      style="
        display: flex;
        justify-content: space-between;
        padding: 10px;
        min-height: 180px;
      "
    >
      <div style="max-width: 75px; padding: 10px; margin: 10px">
        <slot name="image"></slot>
        <slot
          style="text-align: center; margin-top: 10px"
          class="category"
          name="title"
        ></slot>
      </div>
      <div style="display: flex; margin-right: 20px; align-items: end">
        <slot name="count"></slot>
      </div>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "stats-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Cards/StatsCard.vue